import { useQueryWithUserId } from '@northladder/services';

import { AUTO_ASSESSMENTS_API } from '../autoAssessmentsAPIClient';
import { IAutoAssessmentsFiltersPayload } from '../types';

export const AUTO_ASSESSMENTS_FILTERS_KEY = 'auto-assessments-filters-key';

interface IUseAutoAssessmentsFiltersQueryOptions
  extends IAutoAssessmentsFiltersPayload {
  identifier?: string;
}

/**
 * Performs a filter request and retrieves the auto assessments filter options.
 */
export const useAutoAssessmentsFiltersQuery = ({
  search,
  identifier,
}: IUseAutoAssessmentsFiltersQueryOptions) => {
  const {
    isError,
    isPending,
    error,
    data,
    refetch: updateAutoAssessmentsFilters,
  } = useQueryWithUserId({
    queryKey: [AUTO_ASSESSMENTS_FILTERS_KEY, search, identifier],
    networkMode: 'always',
    queryFn: () =>
      AUTO_ASSESSMENTS_API.fetchAllAssessmentsFilters({ search }, identifier),
    refetchInterval: 10000,
  });

  return {
    error,
    isError,
    isPending,
    data,
    updateAutoAssessmentsFilters,
  };
};
